import { render, staticRenderFns } from "./Attend.vue?vue&type=template&id=227ea93d&scoped=true&"
import script from "./Attend.vue?vue&type=script&lang=js&"
export * from "./Attend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ea93d",
  null
  
)

export default component.exports